import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsWidgetConfigurationInstallRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-widget-configuration-install',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/embed/:widgetId/install',
	exact: true,
};
